export default "__VITE_ASSET__D0G97x8e__"